import {AOperationWithEquipment} from "./AOperationWithEquipment";
import {AElement} from "../elements/AElement";
import GPSCoordinates from "../GPSCoordinates";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";
import MarkerIconService from "../../services/map/MarkerIconService";
import {CSS_CLASS_NAME_GRAY_MARKER, CSS_CLASS_NAME_ORANGE_MARKER} from "../../services/UtilsService";
import RemapService from "../../services/RemapService";

export class UninstallElement extends AOperationWithEquipment {

    private _oldElement: AElement | undefined;

    constructor(id: string, idUser: string, date: Date, equipmentId?: string, oldElement?: AElement, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string) {
        const icon = new Icon(
            MarkerIconService.OPERATION_UNINSTALL_ELEMENT_ICON_PATH,
            MarkerIconService.generateIcon(MarkerIconService.OPERATION_UNINSTALL_ELEMENT_ICON_PATH, isSynchro ? CSS_CLASS_NAME_ORANGE_MARKER : CSS_CLASS_NAME_GRAY_MARKER)
        );
        super(id, idUser, EOperationType.UninstallationElement, date, icon, geolocation, isSynchro, commentary, equipmentId);
        this._oldElement = oldElement;
    }

    get oldElement(): AElement | undefined {
        return this._oldElement;
    }

    set oldElement(value: AElement | undefined) {
        this._oldElement = value;
    }

    public static remapObjectToOperation(object: any): UninstallElement | null {
        let operation: UninstallElement | null = null;
        if(
            object._id &&
            object._idUser &&
            object._date &&
            object._geolocation &&
            object._oldElement &&
            object._equipmentId
        ) {
            const location = GPSCoordinates.remapObjectToGPSCoordinate(object._geolocation);
            const oldElement = RemapService.remapObjectToElement(object._oldElement);
            if(location && oldElement) {
                operation = new UninstallElement(
                    object._id,
                    object._idUser,
                    object._date,
                    object._equipmentId,
                    oldElement,
                    location,
                    object._isSynchro,
                    object._commentary
                );
            }
        }
        return operation;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.oldElement !== undefined &&
            this.oldElement.isCorrect()
        );
    }
}
